export const mediaControlButtonClass =
  'hover:bg-[color-mix(in_srgb,currentColor_20%,transparent)] p-2.5 sm:p-1.5 rounded-full transition-colors';

export const mediaRangeClass =
  'media-range h-6 sm:h-4 bg-transparent appearance-none cursor-pointer';

export const mediaControlLabelButtonClass =
  'hover:bg-[color-mix(in_srgb,currentColor_20%,transparent)] px-3 py-2.5 sm:py-1.5 rounded-full text-sm leading-6 font-semibold tabular-nums transition-colors';
